module.exports = __webpack_public_path__ + "assets/img/wifiIcon.252e587d.svg";